module.exports = __webpack_public_path__ + "img/bag.f9e1c1e2.svg";